import { BanTableColumnCaptions } from "./tableColumnCaptions";
import HistoryTableHeader from "./historyTableHeader";
import React from "react";

const BanHistoryTableHeader = (props) => {
  const { editedFields, objectData } = props;

  const title = [
    {
      title: BanTableColumnCaptions.device.key,
      value: objectData ? objectData.device.key : "",
    },
  ];

  return (
    <HistoryTableHeader
      editedFields={editedFields}
      captions={BanTableColumnCaptions}
      objectData={objectData}
      title={title}
    />
  );
};

export default BanHistoryTableHeader;



// WEBPACK FOOTER //
// ./src/components/banHistoryTableHeader.js